const dayjs = require("dayjs");

const isPromoCodeEndDateValid = endDate => {
  if (!endDate) {
    return false;
  }

  if (
    dayjs(new Date(endDate))
      .startOf("day")
      .isBefore(dayjs().startOf("day"))
  ) {
    return false;
  }

  return true;
};

module.exports = { isPromoCodeEndDateValid };
